import { styled } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

// A faixa inferior de navegacao (56px) foi removida 2026-10-21 - a troca
// entre lista e conversa no mobile agora e' so' tela cheia (sem aba fixa
// embaixo), entao nao reserva mais essa primeira linha do grid.
const TicketAdvancedLayout = styled(Paper)({
    height: `calc(100% - 48px)`,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
})

export default TicketAdvancedLayout;